"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _InspirationOrgContext = _interopRequireDefault(require("../context/InspirationOrgContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var SHOOTSTA_ORG = {
  organisation: {
    organisationId: 'f4e7f2c7-7911-4ca9-84f0-4b3ca37249bd',
    name: 'Shootsta',
    alias: 'shootsta'
  }
};
/**
 * Get initial state for inspiration context as per current selected org
 */

var getOrgDetails = (0, _memoizeOne.default)(function (organisationId, organisationMemberships) {
  var orgDetails = organisationMemberships.find(function (membership) {
    return membership.organisation.organisationId === organisationId;
  });
  return orgDetails ? orgDetails.organisation : organisationMemberships[0].organisation;
});
var hasShootstaOrgMembership = (0, _memoizeOne.default)(function (organisationMemberships) {
  var shootstaOrgIndex = organisationMemberships.findIndex(function (_ref) {
    var organisation = _ref.organisation;
    return organisation.organisationId === SHOOTSTA_ORG.organisation.organisationId;
  });
  return shootstaOrgIndex >= 0;
});

var InspirationOrgProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(InspirationOrgProvider, _React$Component);

  function InspirationOrgProvider(props) {
    var _this;

    _classCallCheck(this, InspirationOrgProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InspirationOrgProvider).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getProviderValue", (0, _memoizeOne.default)(function (selectedInspirationOrgId, organisationMemberships) {
      return {
        selectedInspirationOrgId: selectedInspirationOrgId,
        setSelectedOrgId: _this.setSelectedOrgId,
        organisationMemberships: organisationMemberships
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "updateMemberships", function () {
      var _this$props = _this.props,
          organisationId = _this$props.organisationId,
          organisationMemberships = _this$props.organisationMemberships;
      var availabileOrgMemberships = hasShootstaOrgMembership(organisationMemberships) ? organisationMemberships : [].concat(_toConsumableArray(organisationMemberships), [SHOOTSTA_ORG]);

      _this.setState({
        selectedInspirationOrgId: getOrgDetails(organisationId, availabileOrgMemberships).organisationId,
        organisationMemberships: availabileOrgMemberships
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setSelectedOrgId", function (selectedInspirationOrgId) {
      _this.setState({
        selectedInspirationOrgId: selectedInspirationOrgId
      });
    });

    _this.state = {
      selectedInspirationOrgId: '',
      organisationMemberships: []
    };
    return _this;
  }

  _createClass(InspirationOrgProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateMemberships();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var organisationId = this.props.organisationId;

      if (prevProps.organisationId === organisationId) {
        return;
      }

      this.updateMemberships();
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var _this$state = this.state,
          selectedInspirationOrgId = _this$state.selectedInspirationOrgId,
          organisationMemberships = _this$state.organisationMemberships;

      if (!selectedInspirationOrgId) {
        return null;
      }

      return React.createElement(_InspirationOrgContext.default.Provider, {
        value: this.getProviderValue(selectedInspirationOrgId, organisationMemberships)
      }, children);
    }
  }]);

  return InspirationOrgProvider;
}(React.Component);

exports.default = InspirationOrgProvider;